import React, { useEffect, useState } from "react";
import "./Slider.scss";
import { Button, Intent, Position, Tooltip } from "@focus/focusUI";
import { IconNames, AnchorButton, Slider } from "@focus/focusUI";
import "./TimeSelector.scss";
export const SpeedSelector = ({ onChange, value, onPlay, onPause, onReverse, min, max, isPaused, canUseLive, onLive, }) => {
    const [sliderValue, setSliderValue] = useState(1);
    const handleChange = (clickedValue) => {
        const value = getScaledValue(clickedValue, min, max);
        setSliderValue(clickedValue);
        onChange(value);
    };
    useEffect(() => {
        if (value !== sliderValue) {
            onChange(sliderValue);
        }
    }, [min, max]);
    useEffect(() => {
        const newSpeedValue = Number(value);
        if (Math.sign(sliderValue) !== Math.sign(newSpeedValue)) {
            setSliderValue((prevInputValue) => {
                if (Math.sign(sliderValue) !== Math.sign(newSpeedValue)) {
                    return -1 * prevInputValue;
                }
                return prevInputValue;
            });
        }
    }, [value]);
    return (React.createElement("div", { className: "speed-selector" },
        React.createElement("div", { className: "time-slider", style: {
                display: "flex",
                alignItems: "center",
                gap: "3px",
            } },
            React.createElement("div", { style: { position: "relative", flex: 1 } },
                React.createElement(Slider, { min: -100, max: 100, stepSize: 0.01, labelStepSize: 100, labelRenderer: (value) => getScaledValue(value, min, max).toString(), onChange: handleChange, showTrackFill: false, value: sliderValue }))),
        React.createElement("div", { className: "buttons-container", style: {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
            } },
            React.createElement(Button, { active: value < 0 && !isPaused, icon: IconNames.PLAY, intent: !isPaused && value < 0 ? Intent.PRIMARY : Intent.NONE, onClick: onReverse, "aria-label": "backward", style: { rotate: "180deg" }, minimal: true }),
            React.createElement(Button, { active: isPaused, icon: IconNames.PAUSE, className: isPaused ? "intermittent-slow" : undefined, intent: isPaused ? Intent.DANGER : Intent.NONE, onClick: onPause, "aria-label": "pause", minimal: true }),
            React.createElement(Button, { active: value > 0 && !isPaused, icon: IconNames.PLAY, intent: !isPaused && value > 0 ? Intent.PRIMARY : Intent.NONE, onClick: onPlay, "aria-label": "forward", minimal: true }),
            React.createElement(Tooltip, { content: "No visible element has values for current date", position: Position.TOP, openOnTargetFocus: false, disabled: canUseLive },
                React.createElement(AnchorButton, { icon: IconNames.Time, intent: Intent.NONE, onClick: onLive, "aria-label": "real time", disabled: !canUseLive, minimal: true })))));
};
function getScaledValue(value, min, max) {
    const logMin = Math.log10(Math.abs(min));
    const logMax = Math.log10(Math.abs(max));
    const range = logMax - logMin;
    const scaledValue = Math.sign(value) * Math.pow(10, (Math.abs(value) * range) / 100 + logMin);
    return Number(scaledValue.toFixed(0));
}
//# sourceMappingURL=SpeedSelector.js.map